// Update version numbers here to change PDFs across the entire app

import Help from "../assets/pdfs/Help.pdf";
import Japan_user_guide_2024 from "../assets/pdfs/Japan_user_guide_2024.pdf";

export const PdfEnglish = Help;
export const PdfJapanese = Japan_user_guide_2024;
